export const getHeaderText = (discountPercent: number) =>
  `Save ${discountPercent}%  on your subscription.`

export const getBodyText = (price: string, baseprice: number) =>
  `Unlock plagiarism checks, unlimited citations in 7,000+ styles and expert help with your writing. Get instant access for only <b><s>$${baseprice}</s> ${price}/month</b> after your 3-day trial. Cancel anytime.`

export const CLAIM_OFFER_NOW = 'Claim offer now'
